import React from "react";
import { Link } from "react-router-dom";
import { Play, ArrowRight } from "lucide-react";

const WALL = "/designs/aop/aop_sabotage_skunk.png";

export const DropSpotlight = () => (
  <section className="relative overflow-hidden border-y border-white/10" data-testid="home-drop-spotlight">
    <div
      className="absolute inset-0 opacity-25"
      style={{ backgroundImage: `url(${WALL})`, backgroundSize: "360px", backgroundRepeat: "repeat" }}
      aria-hidden
    />
    <div className="absolute inset-0 bg-gradient-to-r from-black via-black/90 to-black/60" aria-hidden />
    <div className="relative max-w-[1400px] mx-auto px-4 md:px-8 py-14 md:py-20 grid md:grid-cols-[1.3fr_1fr] gap-10 items-center">
      <div>
        <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.24em] text-neon">
          <span className="w-2 h-2 rounded-full bg-neon animate-pulse" /> New drop · live now
        </span>
        <h2 className="font-display text-5xl md:text-7xl text-white leading-[0.9] mt-4">
          THE SKUNK CREW
        </h2>
        <p className="mt-5 max-w-lg text-white/70 leading-relaxed">
          16 new Sabotage graffiti tees, all-over-print skunk socks, and{" "}
          <span className="text-neon font-semibold">$10 bundle sets</span> — tee + matching socks,
          auto-applied at checkout.
        </p>
        <div className="mt-8 flex flex-wrap gap-4">
          <Link
            to="/sabotage"
            data-testid="spotlight-shop-btn"
            className="inline-flex items-center gap-2 bg-neon text-black font-bold uppercase tracking-[0.14em] text-sm px-8 py-4 rounded-full hover:brightness-95 transition"
          >
            Shop the drop <ArrowRight size={16} />
          </Link>
          <a
            href="/promo-sabotage.html"
            target="_blank"
            rel="noreferrer"
            data-testid="spotlight-reel-btn"
            className="inline-flex items-center gap-2 border border-white/30 text-white font-bold uppercase tracking-[0.14em] text-sm px-8 py-4 rounded-full hover:border-neon hover:text-neon transition"
          >
            <Play size={16} /> Watch the reel
          </a>
        </div>
      </div>

      <div className="relative grid grid-cols-2 gap-3">
        <img
          src="/designs/sabotage/crops/11_B4-banjo-skunk.png"
          alt="Sabotage Banjo Skunk Tee"
          loading="lazy"
          className="rounded-xl border border-white/10 object-cover aspect-[4/5] w-full translate-y-3 img-zoom"
        />
        <img
          src="/designs/sabotage/mock_sock_skunk.jpg"
          alt="Sabotage graffiti socks"
          loading="lazy"
          className="rounded-xl border border-white/10 object-cover aspect-[4/5] w-full -translate-y-3 img-zoom"
        />
        <span className="absolute bottom-1 left-1/2 -translate-x-1/2 text-[10px] font-bold uppercase tracking-[0.14em] px-3 py-1 rounded-full bg-neon text-black">
          Bundle · Save $10
        </span>
      </div>
    </div>
  </section>
);

export default DropSpotlight;
